import React from 'react';
import { motion } from 'framer-motion';
import { WhatsAppButton } from './WhatsAppButton';
import { Button } from './Button';
export const Hero: React.FC = () => {
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden" data-id="element-77">
      {/* Decorative Blobs */}
      <motion.div animate={{
      rotate: [0, 10, -10, 0],
      scale: [1, 1.05, 0.95, 1]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-20 -left-20 w-64 h-64 bg-primary border-3 border-text blob-1 opacity-80 -z-10" data-id="element-78" />
      <motion.div animate={{
      rotate: [0, -15, 10, 0],
      scale: [1, 0.9, 1.1, 1]
    }} transition={{
      duration: 12,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} className="absolute bottom-10 -right-10 w-80 h-80 bg-secondary border-3 border-text blob-2 opacity-80 -z-10" data-id="element-79" />
      <motion.div animate={{
      rotate: [0, 20, -5, 0],
      y: [0, -20, 20, 0]
    }} transition={{
      duration: 15,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} className="absolute top-40 right-20 w-32 h-32 bg-accent border-3 border-text blob-3 opacity-80 -z-10 hidden md:block" data-id="element-80" />

      <div className="container mx-auto px-4" data-id="element-81">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-82">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left z-10" data-id="element-83">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-84">
              <div className="inline-block bg-white border-2 border-text rounded-full px-4 py-1.5 font-bold text-sm mb-6 neo-shadow-sm transform -rotate-2" data-id="element-85">
                Clínica Veterinaria Urbana 🏥
              </div>
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-black leading-[1.1] mb-6" data-id="element-86">
                Donde cada patita recibe{' '}
                <span className="text-primary inline-block transform -rotate-2" data-id="element-87">
                  amor
                </span>{' '}
                y cuidado{' '}
                <span className="text-secondary inline-block transform rotate-2" data-id="element-88">
                  experto
                </span>
              </h1>
              <p className="text-xl md:text-2xl font-medium mb-8 max-w-2xl mx-auto lg:mx-0 text-gray-800" data-id="element-89">
                Atención veterinaria moderna, cercana y sin estrés. Porque tu
                mascota es familia, y merece lo mejor.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-90">
                <WhatsAppButton variant="primary" className="w-full sm:w-auto text-xl py-4 px-8" data-id="element-91" />
                <Button href="#servicios" variant="white" className="w-full sm:w-auto text-xl py-4 px-8" data-id="element-92">
                  Conocer Servicios
                </Button>
              </div>
            </motion.div>
          </div>

          {/* Illustration Area */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 w-full max-w-lg relative z-10" data-id="element-93">
            <div className="relative w-full aspect-square bg-white border-3 border-text rounded-[3rem] neo-shadow-lg p-8 flex items-center justify-center transform rotate-3" data-id="element-94">
              <div className="absolute inset-0 bg-accent rounded-[3rem] -z-10 transform -rotate-6 border-3 border-text" data-id="element-95"></div>

              {/* Emoji Composition */}
              <div className="relative w-full h-full flex items-center justify-center" data-id="element-96">
                <motion.div animate={{
                y: [0, -10, 0]
              }} transition={{
                duration: 4,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="text-[8rem] md:text-[10rem] absolute z-20" data-id="element-97">
                  🐕
                </motion.div>
                <motion.div animate={{
                y: [0, 10, 0]
              }} transition={{
                duration: 3.5,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 0.5
              }} className="text-[6rem] md:text-[7rem] absolute -bottom-4 right-4 z-30" data-id="element-98">
                  🐈
                </motion.div>
                <motion.div animate={{
                rotate: [0, 15, -15, 0]
              }} transition={{
                duration: 5,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="text-5xl absolute top-10 left-10 z-10" data-id="element-99">
                  🦴
                </motion.div>
                <motion.div animate={{
                scale: [1, 1.2, 1]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="text-5xl absolute top-20 right-10 z-10" data-id="element-100">
                  ✨
                </motion.div>
                <motion.div animate={{
                rotate: [0, -20, 20, 0]
              }} transition={{
                duration: 4.5,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 1
              }} className="text-4xl absolute bottom-20 left-4 z-10" data-id="element-101">
                  🎾
                </motion.div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};